import libphonenumber from 'google-libphonenumber'

export const parsePhoneNumber = (number: string | undefined = undefined) => {
  if (!number) {
    return
  }

  try {
    const phoneNumberUtil = libphonenumber.PhoneNumberUtil.getInstance()
    const parsedPhone = phoneNumberUtil.parse(number)
    return parsedPhone
  } catch (e) {
    return undefined
  }
}
export const isValidPhoneNumber = (
  phoneCode: string | null | undefined,
  phoneNumber: string | null | undefined
) => {
  if (!phoneCode || !phoneNumber) return true

  const phoneNumberUtil = libphonenumber.PhoneNumberUtil.getInstance()
  const parsedPhone = parsePhoneNumber(`${phoneCode}${phoneNumber}`)

  const isValid =
    !!parsedPhone && !!parsedPhone.getCountryCode() && phoneNumberUtil.isValidNumber(parsedPhone)

  return isValid
}

export const isMobilePhoneNumber = (
  phoneCode: string | null | undefined,
  phoneNumber: string | null | undefined
) => {
  if (!phoneCode || !phoneNumber) return true

  const mobileTypes = [
    libphonenumber.PhoneNumberType.MOBILE,
    libphonenumber.PhoneNumberType.FIXED_LINE_OR_MOBILE,
  ]
  const phoneNumberUtil = libphonenumber.PhoneNumberUtil.getInstance()
  const parsedPhone = parsePhoneNumber(`${phoneCode}${phoneNumber}`)

  return !!parsedPhone && mobileTypes.includes(phoneNumberUtil.getNumberType(parsedPhone))
}
